import React from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { HOME_EMOJI_OPTIONS } from "../../../constants/institutionalIconOptions";

export default function EmojiIconPicker({ value, onChange, label = "Ícone" }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.75 }}>
        {label}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1 }}>
        {HOME_EMOJI_OPTIONS.map((emoji) => (
          <Button
            key={emoji}
            size="small"
            variant={value === emoji ? "contained" : "outlined"}
            onClick={() => onChange(emoji)}
            sx={{ minWidth: 44, fontSize: "1.25rem", p: 0.5 }}
          >
            {emoji}
          </Button>
        ))}
      </Box>
      <TextField
        size="small"
        fullWidth
        label="Ou digite um emoji"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{ maxLength: 4 }}
      />
    </Box>
  );
}
